export default [
    {
        key: "about",
        label: "About"
    },
    {
        key: "project",
        label: "Project"
    },
    {
        key: "contact",
        label: "Contact"
    }
]